// src/Components/GoogleMap/MapLoader.js

let googleApi = null;
let loadingPromise = null;

export const loadGoogleMapsApi = () => {
  // 1. If already loaded, return immediately
  if (googleApi) return Promise.resolve(googleApi);

  if (window.google && window.google.maps) {
    googleApi = window.google;
    return Promise.resolve(googleApi);
  }

  // 2. If currently loading, return the existing promise to prevent duplicate scripts
  if (loadingPromise) return loadingPromise;

  // 3. Start a new load
  loadingPromise = new Promise((resolve, reject) => {
    window.__loadMapsReady = () => {
      if (window.google && window.google.maps) {
        googleApi = window.google;
        resolve(window.google);
      } else {
        reject(new Error('Google Maps failed to initialize'));
      }
    };

    const script = document.createElement('script');
    const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

    // Standard URL with loading=async to satisfy console warnings
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&v=weekly&libraries=geometry,marker&loading=async&callback=__loadMapsReady`;
    script.async = true;
    script.defer = true;

    script.onerror = () => {
      loadingPromise = null; // Allow retry on error
      reject(new Error('Google Maps script error'));
    };

    document.head.appendChild(script);
  });

  return loadingPromise;
};
